module.exports = __webpack_public_path__ + "img/desafio.c9aa16af.png";